import React from "react";
import "../App.css";
import "../bootstrap.css";
import {
  Cancer,
  Cardiology,
  ChronicCondition,
  Therapeutic,
  arrowRight,
  Covid,
} from "../features/theme/icons";
const options = [
  { color: "#8CD2A9", title: "Respiratory Syncytial Virus", icon: Cardiology ,link:" /study/NCT05127434"},
  { color: "#F6BFBF", title: "COVID-19", icon: Covid ,link:"/study/NCT04860297"},
  { color: "#C9AFD2", title: "Cytomegalovirus Virus CMV", icon: ChronicCondition ,link:" /study/NCT05085366"},
  { color: "#76D6EE", title: "Cancer", icon: Cancer ,link:"/results?q=Cancer&in=UNITED%20STATES"},
  // { color: "#8CD2A9", title: "Cytomegalovirus", icon: Cardiology,link:"/study/NCT04232280" },
  { color: "#F2D888", title: "Eczema", icon: Therapeutic,link:"/study/NCT04773600" },
];

const Option = ({ color, title, icon , link , next}) => {
  return (
    // <div onClick={()=>next(link)} className="options">
    //   <div className="option d-flex">
    //     <div style={{ backgroundColor: color }} className="icon_bg">
    //       <img src={icon} alt={"condition"}></img>
    //     </div>
    //     <p>{title}</p>
    //   </div>
    //   <span>
    //     <img src={arrowRight} alt="arrow right"></img>
    //   </span>
    // </div>
    <div onClick={()=>next(link)} className="d-flex align-items-center justify-content-between options">
        <div className="option d-flex align-items-center justify-content-center">
           <div style={{ backgroundColor: color }} className="icon_bg">
             <img src={icon} alt={"condition"}></img>
           </div>
           <p className='mb-0'>{title}</p>
        </div>
        <img src={arrowRight} alt="arrow right"></img>
    </div>
  );
};


const PopularSearch = (props) => {

  const next =(link)=>{
    window.location.href = link
  }

  return (
    <div className="container">
      <p className="pop_text">POPULAR SEARCH</p>
      {options.map((item,i) => (
        <Option key={i} color={item.color} title={item.title} icon={item.icon} link={item.link} next = {next} />
      ))}
    </div>
  );
};

export default PopularSearch;
